import React, { Component } from "react";
import { Link } from "react-router-dom";

class ClaimCreateMileage extends Component {
  render() {
    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 22 }}>
          <h4 style={{ margin: 0, fontWeight: 900, color: "#0F172A" }}>
            Create Mileage Claim
          </h4>
          <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
            Claim mileage expenses for official travel using a personal vehicle.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 22 }}>
          <div>
            <div style={card}>
              <h5 style={sectionTitle}>Mileage Claim Information</h5>

              <div style={grid4}>
                {this.renderInput("Employee Name *", "Izzah Maisarah Binti Kamal")}
                {this.renderInput("Employee ID", "EMP-2024-0093", true)}
                {this.renderInput("Department *", "Procurement")}
                {this.renderInput("Claim Reference *", "MLG-2024-0048")}
                {this.renderInput("Vehicle No. *", "QAB 1123")}
                {this.renderInput("Vehicle Type *", "Car")}
                {this.renderInput("Mileage Rate (RM/KM)", "0.80")}
                {this.renderInput("Claim Period *", "01 May 2024 - 17 May 2024")}
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Mileage Trip Items</h5>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#F8FAFC" }}>
                    {[
                      "#",
                      "Date",
                      "From",
                      "To",
                      "Purpose",
                      "KM",
                      "Rate",
                      "Amount (RM)",
                      "Action",
                    ].map((h) => (
                      <th key={h} style={thStyle}>{h}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {[
                    ["1", "03 May 2024", "Office", "Supplier Warehouse", "Supplier inspection", "28.0", "0.80", "22.40"],
                    ["2", "08 May 2024", "Office", "Client Site A", "Contract discussion", "42.5", "0.80", "34.00"],
                    ["3", "14 May 2024", "Office", "Government Office", "Document submission", "35.0", "0.80", "28.00"],
                    ["4", "17 May 2024", "Office", "Event Venue", "Site preparation", "76.5", "0.80", "61.20"],
                    ["5", "Select date", "Start location", "End location", "Enter purpose", "0.0", "0.80", "0.00"],
                  ].map((row) => (
                    <tr key={row[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                      <td style={tdStyle}>{row[0]}</td>
                      <td style={tdStyle}><input value={row[1]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[2]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[3]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[4]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[5]} readOnly style={{ ...tableInput, textAlign: "right" }} /></td>
                      <td style={tdStyle}><input value={row[6]} readOnly style={{ ...tableInput, textAlign: "right" }} /></td>
                      <td style={tdStyle}><input value={row[7]} readOnly style={{ ...tableInput, textAlign: "right" }} /></td>
                      <td style={tdStyle}><button style={deleteButton}>🗑</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button style={{ ...secondaryButton, marginTop: 14 }}>+ Add Mileage Item</button>

              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 14, marginTop: 18 }}>
                <div style={{ fontWeight: 900 }}>TOTAL MILEAGE CLAIM (RM)</div>
                <div style={totalBox}>145.60</div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Supporting Documents</h5>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
                <div style={uploadBox}>
                  <div style={{ fontSize: 30 }}>☁</div>
                  <div style={{ marginTop: 8, color: "#64748B" }}>
                    Drag and drop mileage documents here, or <b>click to browse</b>
                  </div>
                  <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 6 }}>
                    Trip log, map screenshot, approval or supporting documents. PDF, JPG, PNG up to 10MB each.
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: 900, marginBottom: 10 }}>Uploaded Documents (3)</div>
                  {["Mileage_Log_May2024.pdf", "Map_Route_Screenshots.pdf", "Supplier_Visit_Approval.pdf"].map((file) => (
                    <div key={file} style={fileRow}>
                      <span>{file}</span>
                      <span style={{ color: "#94A3B8" }}>×</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Declaration</h5>

              <label style={{ display: "flex", gap: 10, fontSize: 13, color: "#334155" }}>
                <input type="checkbox" defaultChecked />
                I confirm that the mileage claimed was incurred for approved official duties using my personal vehicle.
              </label>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, marginTop: 18 }}>
                {this.renderInput("Signature of Employee", "Izzah Maisarah Binti Kamal")}
                {this.renderInput("Date", "20 May 2024")}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 18 }}>
              <Link to="/claim/create" style={secondaryLink}>Back</Link>
              <div style={{ display: "flex", gap: 10 }}>
                <button style={secondaryButton}>Save Draft</button>
                <button style={primaryButton}>Submit Claim ›</button>
              </div>
            </div>
          </div>

          <div>
            <div style={sideCard}>
              <h5 style={sectionTitle}>Claim Summary</h5>
              {this.renderSideRow("Trip Items", "4")}
              {this.renderSideRow("Total KM", "182.0 km")}
              {this.renderSideRow("Mileage Rate", "RM 0.80 / km")}
              {this.renderSideRow("Total Amount", "RM 145.60")}
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Mileage Calculator</h5>
              {this.renderSideRow("Formula", "KM × Rate")}
              {this.renderSideRow("Example", "28.0 × 0.80")}
              {this.renderSideRow("Amount", "RM 22.40")}
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Document Check</h5>
              <div style={checkRow}>✓ Mileage log attached</div>
              <div style={checkRow}>✓ Route screenshots attached</div>
              <div style={checkRow}>✓ Supporting approval attached</div>
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Policy Notes</h5>
              <ul style={sideText}>
                <li>Mileage claims must be related to official duties.</li>
                <li>Start and end locations must be clearly stated.</li>
                <li>Duplicate claims for the same trip are not allowed.</li>
                <li>Rate should follow the approved company mileage policy.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInput(label, value, disabled = false) {
    return (
      <div>
        <label style={labelStyle}>{label}</label>
        <input value={value} readOnly disabled={disabled} style={inputStyle} />
      </div>
    );
  }

  renderSideRow(label, value) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
        <span style={{ color: "#64748B", fontSize: 13 }}>{label}</span>
        <b style={{ color: "#0F172A", fontSize: 13 }}>{value}</b>
      </div>
    );
  }
}

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginBottom: 16,
};

const sideCard = {
  ...card,
  marginBottom: 16,
};

const sectionTitle = {
  margin: "0 0 16px",
  fontWeight: 900,
  color: "#0F172A",
};

const grid4 = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 800,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 38,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
  background: "#fff",
};

const thStyle = {
  padding: "10px 12px",
  textAlign: "left",
  fontWeight: 900,
  fontSize: 12,
  color: "#334155",
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: 8,
  fontSize: 13,
  color: "#334155",
};

const tableInput = {
  width: "100%",
  height: 34,
  border: "1px solid #E5E7EB",
  borderRadius: 6,
  padding: "0 10px",
  fontSize: 12,
  background: "#fff",
};

const totalBox = {
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 16px",
  minWidth: 170,
  textAlign: "right",
  fontWeight: 900,
  fontSize: 18,
};

const uploadBox = {
  border: "1px dashed #CBD5E1",
  borderRadius: 12,
  padding: 28,
  textAlign: "center",
  color: "#334155",
};

const fileRow = {
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "10px 12px",
  marginBottom: 8,
  display: "flex",
  justifyContent: "space-between",
  fontSize: 13,
};

const deleteButton = {
  border: "1px solid #FECACA",
  color: "#DC111C",
  background: "#fff",
  borderRadius: 6,
  width: 32,
  height: 32,
};

const primaryButton = {
  background: "#DC111C",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "11px 22px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 18px",
  fontWeight: 800,
};

const secondaryLink = {
  ...secondaryButton,
  textDecoration: "none",
};

const sideText = {
  color: "#64748B",
  fontSize: 13,
  lineHeight: "22px",
  paddingLeft: 18,
};

const checkRow = {
  color: "#027A48",
  fontSize: 13,
  fontWeight: 800,
  marginBottom: 10,
};

export default ClaimCreateMileage;